import apiClient from '@shared/apiClient'

const SERVICE_PATH = 'alerts-history/subscriptions'

export const getApiClient = () => apiClient.partneringOnePlus(SERVICE_PATH)
